import React, { useEffect, useRef, useState } from "react";
import api from "../../api";
import PlayArrived from "./PlayArrived";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Card from "@mui/material/Card";
import DialogContentText from "@mui/material/DialogContentText";
import PersonAddAlt1RoundedIcon from "@mui/icons-material/PersonAddAlt1Rounded";
import Game from "../game/Game";
import useTempoReal from "../../utils/tempoReal";
import EstatisticasJogadores from "../game/EstatisticasJogadores";
import AppLayout from "../../components/ui/AppLayout";
import PageHeader from "../../components/ui/PageHeader";
import LoadingState from "../../components/ui/LoadingState";
import GuestToggle from "../../components/GuestToggle";
import PeladaLockButton from "../../components/PeladaLockButton";
import EscalaPelada from "../../components/EscalaPelada";
import BolaPeladaCard from "../../components/BolaPeladaCard";
import AbrirAvaliacaoDialog from "../../components/AbrirAvaliacaoDialog";
import PresencaFab from "../../components/PresencaFab";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import { useNavigate } from "react-router-dom";
import { dataPelada as formatarDataPelada } from "../../utils/dataPelada";
import BolaAnteriorAlerta from "../../components/BolaAnteriorAlerta";

const PlayArrivedPage = () => {
  const [confirmedPlayers, setConfirmedPlayers] = useState([]);
  const [arrivedPlayers, setArrivedPlayers] = useState([]);
  const [undecidedPlayers, setUndecidedPlayers] = useState([]);
  const [declinedPlayers, setDeclinedPlayers] = useState([]);
  const [alteracaoPresenca, setAlteracaoPresenca] = useState(null); // { player, vai } aguardando confirmação da diretoria
  const [confirmArrivedDialogOpen, setConfirmArrivedDialogOpen] =
    useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [playAutenthic, setPlayAutenthic] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const [userLogado, setUserLoagado] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const [anfitriao, setAnfitriao] = useState({});
  const [severity, setSeverity] = useState("success");
  const [openMessage, setOpenMessage] = useState(false);
  const [pelada, setPelada] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false); // Estado de carregamento
  const [guestName, setGuestName] = useState(""); // Nome do convidado
  const [guestDialogOpen, setGuestDialogOpen] = useState(false);
  const [localCheckin, setLocalCheckin] = useState(null); // { latitude, longitude, raio, validar } (Administração › Check-in)
  const [tabValue, setTabValue] = useState(0);
  const [gameData, setGameData] = useState(null);
  const [abrirAvaliacao, setAbrirAvaliacao] = useState(false);
  const [meuStatus, setMeuStatus] = useState("indefinido"); // confirmado | recusou | chegou | indefinido
  const [alterandoPresenca, setAlterandoPresenca] = useState(false);
  const popupExibido = useRef(false); // o pop-up de check-in aparece só uma vez ao entrar na tela
  const navigate = useNavigate();
  const ehDiretoria = userLogado && (userLogado.perfil === "Admin" || userLogado.perfil === "Diretor");

  const confirmArrived = async () => {
    const { user } = playAutenthic;
    await checkLocationAndArrive({ userId: user, peladaId: pelada._id }, null);
    setConfirmArrivedDialogOpen(false);
  };

  const playArrived = async (payload, player) => {
    setLoading(true);
    try {
      const response = await api.post("v2/playArrived", payload);
      if (response.status === 200) {
        await getPeladaActive();
        setMessage("Jogador Adicionado.");
        setSeverity("success");
        setOpenMessage(true);
      }
    } catch (error) {
      console.error("Error marking arrival:", error);
      setMessage(error.response?.data?.error || "Erro ao registrar a chegada.");
      setSeverity("error");
      setOpenMessage(true);
    } finally {
      setLoading(false);
    }
  };

  const removePlayer = async (payload) => {
    setLoading(true);
    try {
      const response = await api.post("deleteArrived", payload);
      await getPeladaActive();
      setMessage("Jogador fora da fila. O check-in continua valendo; use \"Voltar\" se foi engano.");
      setSeverity("success");
      setOpenMessage(true);
    } catch (error) {
      console.error("Error removing player:", error);
      setMessage(error.response.data.error || "Erro ao remover jogador.");
      setSeverity("error");
      setOpenMessage(true);
    } finally {
      setLoading(false);
    }
  };

  // Desfaz o check-in ("Chegou" apertado por engano): o jogador volta para Confirmados
  const desfazerChegada = async (payload) => {
    setLoading(true);
    try {
      const response = await api.post("v2/desfazerChegada", payload);
      await getPeladaActive({ silencioso: true, automatico: true });
      createMessage(response.data?.message || "Check-in desfeito.", "success");
    } catch (error) {
      createMessage(error.response?.data?.error || "Não foi possível desfazer o check-in.", "error");
    } finally {
      setLoading(false);
    }
  };

  const restorePlayer = async (payload) => {
    setLoading(true);
    try {
      await api.post("voltarArrived", payload);
      await getPeladaActive();
      createMessage("Jogador de volta à fila, na mesma posição.", "success");
    } catch (error) {
      createMessage(error.response?.data?.error || "Erro ao devolver jogador à fila.", "error");
    } finally {
      setLoading(false);
    }
  };

  // Arrastou o jogador na fila da concentração (posicao 0 = primeiro)
  // A lista já mostra a nova ordem na hora; a API confirma e a tela atualiza sem bloquear (sem tela de carregamento)
  const moverJogador = async (player, posicao) => {
    try {
      await api.post("moverArrived", { peladaId: pelada._id, arrivedId: player._id, posicao });
      await getPeladaActive({ silencioso: true });
      createMessage("Posição atualizada.", "success");
      return true;
    } catch (error) {
      createMessage(error.response?.data?.error || "Não foi possível mudar a posição.", "error");
      return false;
    }
  };

  // `automatico`: recarga pelo tempo real (outro jogador mudou algo) — sem pop-up, troca de aba ou avisos
  const getPeladaActive = async ({ silencioso = false, automatico = false } = {}) => {
    if (!silencioso) setLoading(true);
    try {
      const response = await api.get("getPeladaActive");
      if (response.data.data != null) {
        const { arrivedPlayers, confirmedPlayers } = response.data.data;
        const filteredConfirmedPlayers = confirmedPlayers.filter(
          (confirmedPlayer) =>
            !arrivedPlayers.some(
              (arrivedPlayer) =>
                arrivedPlayer.user.toString() ===
                  confirmedPlayer.user.toString() &&
                (!confirmedPlayer.guestId ||
                  arrivedPlayer.guestId === confirmedPlayer.guestId)
            )
        );
        setArrivedPlayers(arrivedPlayers);
        setConfirmedPlayers(filteredConfirmedPlayers);
        setUndecidedPlayers(response.data.data.undecidedPlayers || []);
        setDeclinedPlayers(response.data.data.unconfirmedPlayers || []);
        setPelada(response.data.data);
        const pelada = response.data.data;
        console.log(pelada);

        // Situação do usuário logado nesta pelada
        const meuId = userLogado?._id;
        const doUsuario = (p) => !p.guest && String(p.user) === String(meuId);
        const chegou = arrivedPlayers.some(doUsuario);
        const confirmadoSemCheckin = filteredConfirmedPlayers.find(doUsuario);
        const recusou = (pelada.unconfirmedPlayers || []).some((p) => String(p.user) === String(meuId));
        setMeuStatus(chegou ? "chegou" : confirmadoSemCheckin ? "confirmado" : recusou ? "recusou" : "indefinido");

        if (automatico) {
          // nada: o pop-up de check-in só aparece ao entrar na tela
        } else if (
          confirmadoSemCheckin &&
          !popupExibido.current &&
          (ehDiretoria || pelada.checkinBotaoLiberado !== false) &&
          (ehDiretoria || !pelada.checkinAbreEm || Date.now() >= new Date(pelada.checkinAbreEm).getTime())
        ) {
          // Confirmou presença e ainda não fez check-in: oferece o check-in
          popupExibido.current = true;
          setPlayAutenthic(confirmadoSemCheckin);
          setConfirmArrivedDialogOpen(true);
        }
        // Sem troca automática para a aba Partidas: há o atalho "Partidas" na barra de baixo
      } else {
        // Sem pelada aberta (ou recém-fechada): limpa as listas da tela
        setPelada({});
        setArrivedPlayers([]);
        setConfirmedPlayers([]);
        setUndecidedPlayers([]);
        setDeclinedPlayers([]);
        setMeuStatus("indefinido");
        if (!automatico) {
          setMessage("Não há pelada aberta");
          setSeverity("info");
          setOpenMessage(true);
        }
      }
    } catch (error) {
      console.error("Error fetching pelada:", error);
      if (automatico) return;
      setMessage("Ocorreu um erro inesperado: " + error.message);
      setSeverity("error");
      setOpenMessage(true);
    } finally {
      if (!silencioso) setLoading(false);
    }
  };

  const handleAddGuest = async (user) => {
    if (guestName === "") {
      createMessage("Nome do convidado obrigatório", "error");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        userId: user._id,
        peladaId: pelada._id,
        nameGuest: guestName,
      };

      await api.post("addGuest", payload);
      setMessage("Convidado adicionado com sucesso.");
      setSeverity("success");
      setOpenMessage(true);
      setGuestDialogOpen(false); // Fechar o diálogo após adicionar
      await getPeladaActive(); // Atualizar a lista
    } catch (error) {
      console.error("Error adding guest:", error);
      setMessage(error.response.data.error || "Erro ao adicionar convidado.");
      setSeverity("error");
      setOpenMessage(true);
    } finally {
      setLoading(false);
    }
  };

  const alterarPresenca = async (vai) => {
    if (!pelada._id) return;
    setAlterandoPresenca(true);
    try {
      await api.post(vai ? "v2/confirm-attendance" : "v2/negarPelada", { userId: userLogado._id, peladaId: pelada._id });
      createMessage(vai ? "Presença confirmada! Faça o check-in quando chegar na concentração." : "Tudo bem, marcamos que você não vai.", "success");
      await getPeladaActive();
    } catch (error) {
      createMessage(error.response?.data?.error || "Não foi possível atualizar sua presença.", "error");
    } finally {
      setAlterandoPresenca(false);
    }
  };

  // Admin/Diretor confirma ou muda a confirmação de outro jogador
  const confirmarAlteracaoPresenca = async () => {
    const { player, vai } = alteracaoPresenca;
    setAlteracaoPresenca(null);
    setLoading(true);
    try {
      await api.post(vai ? "v2/confirm-attendance" : "v2/negarPelada", { userId: String(player.user), peladaId: pelada._id });
      createMessage(vai ? `${player.user_name} confirmado na pelada.` : `${player.user_name} marcado como "não vai".`, "success");
      await getPeladaActive();
    } catch (error) {
      createMessage(error.response?.data?.error || "Não foi possível alterar a presença.", "error");
    } finally {
      setLoading(false);
    }
  };

  const createMessage = (mensagem, severity) => {
    setMessage(mensagem);
    setSeverity(severity);
    setOpenMessage(true);
  };

  const closeGuestDialog = () => setGuestDialogOpen(false);

  // Função para calcular a distância entre duas coordenadas em metros
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371e3; // Raio da Terra em metros
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distância em metros
  };

  // Check-in: pega a localização do aparelho, avisa na hora se estiver longe do ponto configurado
  // (Administração › Check-in) e envia as coordenadas; a API é quem valida o perímetro.
  const checkLocationAndArrive = async (payload, player) => {
    if (localCheckin && !localCheckin.validar) {
      await playArrived(payload, player);
      return;
    }
    if (!navigator.geolocation) {
      createMessage("Este navegador não informa a localização, que é necessária para o check-in.", "error");
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude, accuracy } = position.coords;
        if (localCheckin) {
          const distancia = Math.round(calculateDistance(latitude, longitude, localCheckin.latitude, localCheckin.longitude));
          // Mesma folga de GPS da API (até 30 m)
          if (distancia - Math.min(accuracy || 0, 30) > localCheckin.raio) {
            createMessage(`Você está a ${distancia} m do local da pelada. O check-in só é liberado a até ${localCheckin.raio} m.`, "error");
            setLoading(false);
            return;
          }
        }
        await playArrived({ ...payload, latitude, longitude, precisao: accuracy }, player);
      },
      (error) => {
        console.error(error);
        createMessage(
          error.code === 1 ? "Permita o acesso à localização para fazer o check-in." : "Não foi possível obter a sua localização. Tente de novo.",
          "error"
        );
        setLoading(false);
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 30000 }
    );
  };

  // Tempo real: outro jogador confirmou, fez check-in, a fila mudou... recarrega sem tela de carregamento
  useTempoReal(() => {
    getPeladaActive({ silencioso: true, automatico: true });
    fetchGameActive({ silencioso: true });
  });

  useEffect(() => {
    getPeladaActive();
    api.get("checkin/local").then((r) => setLocalCheckin(r.data)).catch(() => {});
    fetchGameActive()
  }, []);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  const fetchGameActive = async ({ silencioso = false } = {}) => {
    if (!silencioso) setLoading(true);
    try {
      const response = await api.get("getGameActive");
      console.log("API Response:", response.data);

      if (
        response.data.partida &&
        Object.keys(response.data.partida).length !== 0
      ) {
        setGameData({ ...response.data }); 
      }
    } catch (error) {
      console.error("Error fetching active game:", error);
    } finally {
      if (!silencioso) setLoading(false);
    }
  };

  const dataPelada = pelada.date ? formatarDataPelada(pelada.date, { weekday: "long", day: "2-digit", month: "long" }) : null;

  return (
    <AppLayout>
      <PageHeader
        eyebrow="Pelada"
        title="Confirmação / Ordem de chegada"
        subtitle={dataPelada ? `Pelada de ${dataPelada}${pelada.time ? ` às ${pelada.time}` : ""}` : "Confirmados, chegada na concentração e partidas."}
        actions={
          <>
          <PeladaLockButton
            pelada={pelada}
            onChange={() => { popupExibido.current = true; return getPeladaActive(); }}
            onMessage={createMessage}
          />
          {ehDiretoria && pelada._id && (
            pelada.avaliacao?.status ? (
              <Button variant="outlined" startIcon={<StarRoundedIcon />} onClick={() => navigate(`/avaliacao/${pelada._id}`)}>Ver avaliação</Button>
            ) : (
              <Button variant="outlined" startIcon={<StarRoundedIcon />} onClick={() => setAbrirAvaliacao(true)}>Abrir avaliação</Button>
            )
          )}
          <Button variant="outlined" startIcon={<PersonAddAlt1RoundedIcon />} onClick={() => setGuestDialogOpen(true)} disabled={!pelada._id || !pelada.openGuest} title={pelada._id && !pelada.openGuest ? "A diretoria ainda não liberou convidados" : undefined}>
            {pelada._id && !pelada.openGuest ? "Convidados bloqueados" : "Adicionar convidado"}
          </Button>
          </>
        }
      />
      <BolaAnteriorAlerta />
      <Snackbar
        open={openMessage}
        autoHideDuration={6000}
        onClose={() => setOpenMessage(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setOpenMessage(false)}
          severity={severity}
          elevation={6}
          variant="filled"
        >
          {message}
        </MuiAlert>
      </Snackbar>
      <Backdrop sx={{ color: "#fff", zIndex: 1400 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog
        open={confirmArrivedDialogOpen}
        onClose={() => setConfirmArrivedDialogOpen(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Check-in disponível</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Você já confirmou presença nesta pelada. Deseja realizar seu check-in agora?
          </DialogContentText>
          <DialogContentText variant="caption" sx={{ display: "block", mt: 1.5 }}>
            Sua localização é verificada: o check-in só é aceito na concentração.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setConfirmArrivedDialogOpen(false)} color="inherit">
            Agora não
          </Button>
          <Button variant="contained" onClick={() => confirmArrived(playAutenthic)}>
            Sim, fazer check-in
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={Boolean(alteracaoPresenca)} onClose={() => setAlteracaoPresenca(null)} fullWidth maxWidth="xs">
        <DialogTitle>{alteracaoPresenca?.vai ? "Confirmar presença" : "Marcar que não vai"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {alteracaoPresenca?.vai
              ? `Confirmar ${alteracaoPresenca?.player.user_name} na pelada?`
              : `Marcar que ${alteracaoPresenca?.player.user_name} não vai jogar?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setAlteracaoPresenca(null)} color="inherit">Cancelar</Button>
          <Button variant="contained" color={alteracaoPresenca?.vai ? "success" : "error"} onClick={confirmarAlteracaoPresenca}>
            {alteracaoPresenca?.vai ? "Confirmar" : "Não vai"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={guestDialogOpen} onClose={closeGuestDialog} fullWidth maxWidth="xs">
        <DialogTitle>Adicionar convidado</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            Uma cobrança de diária será lançada na sua conta.
          </DialogContentText>
          <TextField
            autoFocus
            label="Nome do convidado"
            type="text"
            fullWidth
            value={guestName}
            onChange={(e) => setGuestName(e.target.value)}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeGuestDialog} color="inherit">
            Cancelar
          </Button>
          <Button variant="contained" onClick={() => handleAddGuest(playAutenthic)}>
            Confirmar convidado
          </Button>
        </DialogActions>
      </Dialog>
      <GuestToggle
        pelada={pelada}
        onChange={(atualizada) => setPelada((atual) => ({ ...atual, openGuest: atualizada.openGuest }))}
        onMessage={(texto, tipo = "success") => createMessage(texto, tipo)}
        sx={{ mb: 2 }}
      />
      <AbrirAvaliacaoDialog
        open={abrirAvaliacao}
        peladaId={pelada._id}
        onClose={() => setAbrirAvaliacao(false)}
        onAberta={() => {
          setAbrirAvaliacao(false);
          navigate(`/avaliacao/${pelada._id}`);
        }}
      />
      <EscalaPelada peladaId={pelada._id} onMessage={(texto, tipo = "success") => createMessage(texto, tipo)} sx={{ mb: 2 }} />
      <BolaPeladaCard
        pelada={pelada}
        userLogado={userLogado}
        onAtualizar={(bolas) => setPelada((atual) => ({ ...atual, bolas }))}
        onMessage={(texto, tipo) => createMessage(texto, tipo)}
        sx={{ mb: 2 }}
      />
      <Card sx={{ mb: 3 }}>
        <Tabs value={tabValue} onChange={handleChangeTab} variant="fullWidth">
          <Tab label="Lista de chegada" />
          <Tab label="Partidas" />
          <Tab label="Estatísticas" />
        </Tabs>
      </Card>
      {tabValue === 0 && (
        <PlayArrived
          confirmedPlayers={confirmedPlayers}
          arrivedPlayers={arrivedPlayers}
          undecidedPlayers={undecidedPlayers}
          declinedPlayers={declinedPlayers}
          ehDiretoria={ehDiretoria}
          onAlterarPresenca={(player, vai) => setAlteracaoPresenca({ player, vai })}
          playArrived={checkLocationAndArrive}
          removePlayer={removePlayer}
          restorePlayer={restorePlayer}
          desfazerChegada={desfazerChegada}
          meuId={userLogado?._id}
          onMover={moverJogador}
          play={pelada}
          loading={loading}
        />
      )}
      {tabValue === 1 && (
        <Game
          jogadoresNoCheckin={arrivedPlayers.filter((p) => !p.saiu).length}
          podeSortear={ehDiretoria || arrivedPlayers.some((p) => !p.guestId && String(p.user) === String(userLogado?._id))}
        />
      )}
      {tabValue === 2 && (gameData ? (
        <EstatisticasJogadores estatisticas={gameData.estatisticasJogadores} fetchGameActive={fetchGameActive} />
      ) : (
        <LoadingState label="Nenhuma partida registrada ainda." minHeight={160} />
      ))}
      {pelada._id && (
        <PresencaFab
          status={meuStatus}
          carregando={alterandoPresenca}
          onEuVou={() => alterarPresenca(true)}
          onNaoVou={() => alterarPresenca(false)}
        />
      )}
    </AppLayout>
  );
};

export default PlayArrivedPage;
